// extracted by mini-css-extract-plugin
export default {"mainWrapper":"App_mainWrapper__T0u7p","contentWrapper":"App_contentWrapper__wylie","sectionWrapper":"App_sectionWrapper__Z5WTr"};